
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import Layout from '@src/components/layout/layout';
import pageSlugs from '@src/components/layout/pageSlugs';
import Error404Page from '@src/components/pages/Error404Page';

const page404 = () => {
  const { i18n } = useTranslation();
  const locale = i18n.language;

  const otherSlugs = Object.keys(pageSlugs.notFound).map((key) => {
    return {
      locale: key,
      slug: pageSlugs.notFound[key],
    };
  });
  const [isMount, setMount] = useState(false);
  useEffect(() => {
    // update path in browser
    setMount(true);

    window.history.pushState({}, '', '/404');
  }, []);
  if (!isMount) {
    return (
      <></>
    )
  }




  return (
    <Layout locale={locale} otherSlugs={otherSlugs} navTheme="dark">
      <Error404Page pageLocale={locale} />
    </Layout>
  );
};

export default page404;
